import { Button } from 'antd';
import styled from 'styled-components';

export const WebButton = styled(Button)`
  border-color: var(--main-web-color);
  background: var(--main-web-color);
  :hover,
  :focus {
    background-color: var(--main-web-color-light);
  }
`;

export const WrapperTest = styled.div``;
